import React from 'react';
import AresNavBar from '../Layout/NavBar/NavBar';
import SideBar from '../Layout/SideBar/SideBar';

import './index.css';
import RegisterEnterpriseForm from './RegisterEnterpriseForm';

function RegisterEnterprise () {
    return (
        <div>
            <AresNavBar />
            <SideBar />
            <div className="RegisterUser">
                <div className="bg-registerUser">
                    <div className="desktop-form">
                    </div>
                </div>
            </div>
            <RegisterEnterpriseForm/>
        </div>
    );
}

export default RegisterEnterprise;
